export * from './user-login.model';
export * from './user-details.model';
export * from './user-compact-info.model';
export * from './user-sign-up.model';


// WEBPACK FOOTER //
// ./src/models/user/index.ts